module.exports = "./img/desktop_logo.1c36a9c.png";